const styles = theme => ({
  portrait: {},
  fixedButton: {
    padding: theme.spacing(4.5, 0),
    width: '100%',
    '@media (max-width: 1024px)': {
      padding: theme.spacing(2)
    },
    '&$portrait': {
      '@media (max-width: 1023px)': {
        '& $actionArea': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        },
        '& $helpText': {
          marginBottom: 0
        }
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        '& $actionArea': {
          flexDirection: 'column',
          position: 'relative',
          zIndex: 1,
          '& $helpText': {
            marginBottom: theme.spacing(3)
          }
        },
        '& $blueBox': {
          top: 0,
          zIndex: 2
        },
        '& $form': {
          flexDirection: 'column'
        },
        '& $confirmText': {
          marginRight: 0,
          textAlign: 'center'
        }
      }
    }
  },
  donateWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 1
  },
  helpText: {},
  actionArea: {
    position: 'relative',
    zIndex: 1
  },
  howToDonate: {
    color: 'white',
    fontFamily: 'Poppins',
    fontSize: 20,
    transition: 'filter 800ms ease-in-out'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    top: 6,
    marginRight: theme.spacing(2)
  },
  inputRoot: {
    color: 'white'
  },
  inputUnderline: {
    '&:before': {
      borderColor: ['white', '!important']
    },
    '&:after': {
      borderColor: ['white', '!important']
    }
  },
  formHelperError: {
    color: ['white', '!important']
  },
  blueBox: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'all',
    zIndex: 1
  },
  confirmText: {
    fontSize: '1.55rem',
    marginRight: theme.spacing(2),
    lineHeight: '1.6rem'
  },
  confirmButton: {
    background: 'white',
    color: theme.palette.secondary.main,
    borderRadius: '20px',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    padding: '6px 36px',
    height: '42px',
    marginRight: '16px',
    '&.anonymous': {
      fontSize: '.8rem'
    }
  },
  closeConfirmButton: {
    position: 'absolute',
    right: theme.spacing(),
    top: theme.spacing(),
    color: 'white'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/FixedButton/styles.js